import type { ReportTemplate } from 'api/analytics-reports/types';

export interface AvailableReportMetrics {
  performance: string[];
  content: string[];
}

export function collectAvailableReportMetricsFromTemplates(
  templates: ReportTemplate[],
): AvailableReportMetrics {
  const performance = new Set<string>();
  const content = new Set<string>();

  for (const template of templates) {
    for (const defaults of [
      template.profile_defaults,
      template.general_defaults,
    ]) {
      for (const metric of defaults.performance_metrics) {
        performance.add(metric);
      }
      for (const metric of defaults.content_metrics) {
        content.add(metric);
      }
    }
  }

  const sortMetrics = (items: Set<string>) =>
    Array.from(items).sort((a, b) => a.localeCompare(b));

  return {
    performance: sortMetrics(performance),
    content: sortMetrics(content),
  };
}
